export default __webpack_public_path__ + "static/media/animated-navigation.27003e6a.png";